/**
 * 학습결과(시뮬) — api2 `platformGet` 전용. 웹 BFF(`apiClient`) 토큰과 분리.
 * @see .env.example — `REACT_APP_STUDY_RESULT_ACCESS_TOKEN`, `REACT_APP_STUDY_RESULT_PLATFORM_PATH_USER_ID`
 */

/** trim 후 비어 있으면 `undefined` — `platformGet`이 웹 `medicrew_access_token`으로 폴백 */
export function getStudyResultPlatformAccessToken(): string | undefined {
	const raw = process.env.REACT_APP_STUDY_RESULT_ACCESS_TOKEN;
	if (raw == null) return undefined;
	const t = String(raw).trim();
	return t === '' ? undefined : t;
}

/**
 * `fetchScenarioPracticePayload`의 `userId`를 참가자 선택 대신 이 값으로 (Mongo ObjectId 등).
 * 로컬·단일 수강자 검증용 — 운영·다중 참가자 UI에서는 비워 둔다.
 */
export function getStudyResultPlatformPathUserIdOverride(): string | undefined {
	const raw = process.env.REACT_APP_STUDY_RESULT_PLATFORM_PATH_USER_ID;
	if (raw == null) return undefined;
	const t = String(raw).trim();
	return t === '' ? undefined : t;
}
